class EfCollapse {
    $onInit() {
        if (this.cacheKey)
            this.isCollapsed = JSON.parse(localStorage.getItem(this.cacheKey))
    }

    switchCollapsed() {
        this.isCollapsed = !this.isCollapsed

        if (this.cacheKey) {
            localStorage.setItem(this.cacheKey, this.isCollapsed)
        }
    }

    get cacheKey() {
        return this.cacheAs && `ef-collapse-is-${this.cacheAs}-collapsed`
    }
}

angular.module("eficienciaFiscalModule")
    .component("efCollapse", {
        controller: EfCollapse,
        transclude: {
            header: 'efCollapseHeader',
            content: 'efCollapseContent'
        },
        bindings: {
            cacheAs: '@',
            isCollapsed: '=?'
        },
        template: `
            <div>
                <div ng-click="$ctrl.switchCollapsed()">
                    <label class="header">
                        <i ng-show="$ctrl.isCollapsed" class="fa fa-plus"></i>
                        <i ng-hide="$ctrl.isCollapsed" class="fa fa-minus"></i>
                        <div ng-transclude="header" style="margin-left: 5px; width: 100%;"></div>
                    </label>
                </div>
                <div
                    class="slide-animation"
                    ng-hide="$ctrl.isCollapsed"
                    ng-transclude="content"
                    delay="300">
                </div>
            </div>
        `
    })
